export default "__VITE_ASSET__DVSKz2T___"